module.exports = __webpack_public_path__ + "static/serv03-8df59cc99b5d3cc91d88e2bc9c54d3be.png";